import { utcToZonedTime, format as formatDate } from 'date-fns-tz'

export const dateToMoscowTime = (value: number | Date) => {
  return utcToZonedTime(value, 'Europe/Moscow')
}

export const formatDateToMoscowTime = (
  value: number | Date,
  format: string
) => {
  return formatDate(dateToMoscowTime(value), format, {
    timeZone: 'Europe/Moscow',
  })
}
